import { apiRequest } from "@services/apiClient";
import onBoardingsEndpoints from "@services/onBoardings/onBoardingsEndpoints";

function normalizeOnBoardingsFromBody(body) {
  if (Array.isArray(body?.onBoardings)) return body.onBoardings;
  if (Array.isArray(body?.items)) return body.items;
  if (Array.isArray(body)) return body;
  return [];
}

export async function listOnBoardingsRequest() {
  const response = await apiRequest(onBoardingsEndpoints.base);
  return {
    ...response,
    body: normalizeOnBoardingsFromBody(response?.body),
  };
}

export async function createOnBoardingsRequest(payload) {
  const response = await apiRequest(onBoardingsEndpoints.base, {
    method: "POST",
    body: payload,
  });
  return {
    ...response,
    body: normalizeOnBoardingsFromBody(response?.body),
  };
}

export async function updateOnBoardingsRequest(payload) {
  const response = await apiRequest(onBoardingsEndpoints.base, {
    method: "PUT",
    body: payload,
  });
  return {
    ...response,
    body: normalizeOnBoardingsFromBody(response?.body),
  };
}

export async function saveOnBoardingsRequest(payload) {
  try {
    return await updateOnBoardingsRequest(payload);
  } catch (error) {
    if (Number(error?.status) === 404) {
      return createOnBoardingsRequest(payload);
    }
    throw error;
  }
}

export function deleteOnBoardingRequest(id) {
  return apiRequest(onBoardingsEndpoints.byId(id), {
    method: "DELETE",
  });
}
